import slice from "./leadsSlice";

export default slice.reducer;
